import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap, of, catchError, throwError } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';

@Injectable({
  providedIn: 'root'
})
export class ChildReportsService extends BaseRestApiService {

    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    } 
    
    getChildCounts(payload: any): Observable<any> {
        return this.post<any>(EndPoints.studentEligibilityCount, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            schoolYear: payload.schoolYear
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['counts'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    
    }
getChildExportDataCounts
    (payload: any): Observable<any> {
        return this.post<any>(EndPoints.studentEligibilityCountExcel, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            schoolYear: payload.schoolYear
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['students'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    
    }

    getServiceStudentDataCounts(payload: any): Observable<any> {

        return this.post<any>(EndPoints.studentServiceLists_GetStudentsByPartyService, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchools:payload.chosenSchools,           
            performancePeriod:payload.performancePeriod,
            expiredEligibility:payload.expiredEligibility,
            expiredQAD:payload.expiredQAD,
            grades:payload.grades,
            partyServices:payload.partyServices,
            enrollmentPeriods:payload.enrollmentPeriods
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['students'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    
    }

    getEnrollmentSearch(payload: any): Observable<any> {
        return this.post<any>(EndPoints.extendedSearch, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchool: payload.chosenSchools,
            expiredEligibility: payload.expiredEligibility,
            rAttending: payload.rAttending,
            schoolYear: payload.schoolYear
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['schools'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    
    }

    getServiceSearch(payload: any): Observable<any> {
        return this.post<any>(EndPoints.extendedSearch, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchool: payload.chosenSchools,
            expiredEligibility: payload.expiredEligibility,
            rAttending: payload.rAttending,
            schoolYear: payload.schoolYear
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['schools'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    
    }

    getAcademicRiskSearch(payload: any): Observable<any> {
        return this.post<any>(EndPoints.extendedSearch, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchool: payload.chosenSchools,
            expiredEligibility: payload.expiredEligibility,
            rAttending: payload.rAttending,
            schoolYear: payload.schoolYear
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['schools'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    
    }

    getINAView(payload: any): Observable<any> {
        return this.post<any>(EndPoints.extendedSearch, false, '', {
            
            schoolYear: payload.schoolYear
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['schools'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    
    }

    getPFSReport(payload: any): Observable<any> {
        return this.post<any>(EndPoints.extendedSearch, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchool: payload.chosenSchools,
            schoolYear: payload.schoolYear
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['schools'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    
    }

    getGraduationReport(payload: any): Observable<any> {
        return this.post<any>(EndPoints.graduationReport_search, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchool: payload.chosenSchools,
            schoolYear: payload.schoolYear
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['schools'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    
    }

    getCommunicationEvents(payload: any): Observable<any> {
        return this.post<any>(EndPoints.extendedSearch, false, '', {
            chosenRegions: payload.chosenRegions,
            chosenCounties: payload.chosenCounties,
            chosenSchoolDistricts: payload.chosenSchoolDistricts,
            chosenSchool: payload.chosenSchools,
            schoolYear: payload.schoolYear
        }).pipe(
            switchMap((result: any) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['schools'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err: any) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    
    }
}